module.exports = __webpack_public_path__ + "img/pdf.81608db9.svg";